import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Typography, FormControlLabel, Checkbox, Box, Button } from "@material-ui/core";
import {
  fetchAccreditationDetailForms,
  fetchQADetailForms,
  assignFormsToOdkUser,
  fetchOdkUserAssignment,
} from "../actions";

const styles = (theme) => ({
  paper: theme.paper.paper,
  title: theme.paper.title,
  page: theme.page,
});

class AssignFormsUserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formToPublish: [],
      isProcessing: false,
    };
  }

  componentDidMount() {
    const { projectId, detailUuid, userUuid, detailType } = this.props;
    if (projectId) {
      if (detailType === "QA") {
        this.props.fetchQADetailForms(projectId);
      } else {
        this.props.fetchAccreditationDetailForms(projectId);
      }
    }
    if (userUuid) {
      this.props.fetchOdkUserAssignment(userUuid);
    }
  }

  componentDidUpdate(prevProps) {
    const { assigningForms: wasAssigning } = prevProps;
    const { assigningForms, assignFormsSuccess, onClose } = this.props;

    if (wasAssigning && !assigningForms && assignFormsSuccess && this.state.isProcessing) {
      this.setState({ isProcessing: false });
      if (onClose && typeof onClose === "function") {
        onClose();
      }
    }
  }

  handleCheckboxChange = (uuid) => {
    this.setState((prevState) => {
      const { formToPublish } = prevState;
      return {
        formToPublish: formToPublish.includes(uuid)
          ? formToPublish.filter((id) => id !== uuid)
          : [...formToPublish, uuid],
      };
    });
  };

  handleDeployForms = () => {
    const { detailUuid, assignFormsToOdkUser, detailType, userUuid } = this.props;
    const { formToPublish } = this.state;
    this.setState({ isProcessing: true });
    assignFormsToOdkUser(formToPublish, detailUuid, userUuid, detailType, "Assigned Form To User");
  };

  isDeployFormsDisabled = () => !this.state.formToPublish.length || !this.props.detailUuid || this.state.isProcessing;

  render() {
    const {
      classes,
      detailType,
      accreditationDetailsForms,
      qaDetailsForms,
      errorAccreditationDetailsForms,
      errorQADetailsForms,
      assigningForms,
      assignFormsSuccess,
    } = this.props;

    const { formToPublish, isProcessing } = this.state;

    const formList = detailType === "qa" ? qaDetailsForms : accreditationDetailsForms;
    const error = detailType === "qa" ? errorQADetailsForms : errorAccreditationDetailsForms;
    const assignFormsUUIDs = new Set(
      (this.props.odkUserAssignments || []).map((a) => a.odkForm?.uuid || a.uuid).filter(Boolean),
    );

    return (
      <div style={{ width: "100%" }}>
        <Typography className={classes.title}>Forms List</Typography>

        {error && <Typography color="error">Error loading forms: {error.message || "Unknown error"}</Typography>}

        {!formList?.length ? (
          <Typography>No forms available</Typography>
        ) : (
          <div>
            {formList.map((form, index) => {
              const isChecked = assignFormsUUIDs.has(form.uuid);
              if (!form?.odkForm?.formName) {
                return null;
              }

              return (
                <div key={form.uuid || index} style={{ width: "100%" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        value={form.uuid}
                        onChange={() => this.handleCheckboxChange(form.uuid) || isChecked}
                        checked={isChecked || formToPublish.includes(form.uuid)}
                        disabled={isChecked}
                      />
                    }
                    label={form.odkForm.formName}
                  />
                </div>
              );
            })}

            <Box display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                onClick={this.handleDeployForms}
                color="primary"
                disabled={this.isDeployFormsDisabled()}
              >
                {assigningForms || isProcessing ? "Assigning..." : assignFormsSuccess ? "Assigned Form" : "Assign Form"}
              </Button>
            </Box>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  accreditationDetailsForms: state.quality_assurance_and_accreditation?.accreditationDetailsForms || [],
  errorAccreditationDetailsForms: state.quality_assurance_and_accreditation?.errorAccreditationDetailsForms,
  qaDetailsForms: state.quality_assurance_and_accreditation?.qaDetailsForms || [],
  errorQADetailsForms: state.quality_assurance_and_accreditation?.errorQADetailsForms,
  assigningForms:
    state.quality_assurance_and_accreditation?.assigningForms ||
    state.quality_assurance_and_accreditation?.assigningForms,
  assignFormsSuccess:
    state.quality_assurance_and_accreditation?.assignFormsSuccess ||
    state.quality_assurance_and_accreditation?.assignFormsSuccess,
  assignFormsError:
    state.quality_assurance_and_accreditation?.assignFormsError ||
    state.quality_assurance_and_accreditation?.assignFormsError,
  odkUserAssignments: state.quality_assurance_and_accreditation.odkUserAssignments || [],
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAccreditationDetailForms,
      fetchQADetailForms,
      assignFormsToOdkUser,
      fetchOdkUserAssignment,
    },
    dispatch,
  );

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(AssignFormsUserList));
